import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const  noticeRouter: Array<RouteRecordRaw> = [
    {
        path: '/notice',
        name: '通知与教程',
        component: Layout,
        meta: { title: '通知与教程', icon: 'icon-horn', alwaysShow: true },
        children: [
            {
                path: 'notice-list',
                name: '通知列表',
                component: () => import('@/views/notice/NoticeList.vue'),
                meta: { title: '通知列表', badge: 'rule_auths' }
            },
            {
                path: 'training-list',
                name: '商户平台教程',
                component: () => import('@/views/merchant-admin/TrainingList.vue'),
                meta: { title: '平台教程', keepAlive: true, depth: 30, badge: 'courseMsgWarn' }
            },
        ]
    }
]

export default noticeRouter